import { Container, Row, Col } from 'react-bootstrap';
import TimelineStart from "./TimelineStart";
import TimelineMid from "./TimelineMid";
import TimelineEnd from "./TimelineEnd";
import "./Timeline.css";
import { check_date_time } from "../../helper_functions/timeline_helpers.js"

const Timeline = () => {
  
  return(
    <Container fluid className="timeline-wrapper">
      <Row>
        <Col 
          className="timeline-col"
          xs={12}
          sm={12}
          md={4}
          lg={4}
        >
          <TimelineStart 
            event_name="Datasets posted" 
            date_time="February 15th 2022" 
            timeline_reached={check_date_time(2022, 2, 15, 17)} 
          />
        </Col>
        <Col 
          className="timeline-col"
          xs={12}
          sm={12}
          md={4}
          lg={4}
        >
          <TimelineMid 
            event_name="Submissions due" 
            date_time="May 1st 2022" 
            timeline_reached={check_date_time(2022, 5, 1, 12)}
          />
        </Col>
        <Col 
          className="timeline-col"
          xs={12}
          sm={12}
          md={4}
          lg={4}
        >
          <TimelineEnd 
            event_name="Results announced at ACIC 2022" 
            date_time="May 24th &ndash; 25th 2022" 
            timeline_reached={check_date_time(2022, 5, 25, 12)} 
          />
        </Col>
      </Row>
    </Container>

  )
}

export default Timeline;